import { useEffect, useState } from 'react';

const useScript = (url: string, attributes: Record<string, string> = {}) => {
	const [status, setStatus] = useState<'idle' | 'loading' | 'ready' | 'error'>('idle');

	useEffect(() => {
		if (!url) return;

		// Check if the script already exists in the DOM
		let script: HTMLScriptElement | null = document.querySelector(`script[src="${url}"]`);

		if (!script) {
			// Create a new script element if it doesn't exist
			script = document.createElement('script');
			script.src = url;
			script.async = true;

			// Set additional attributes (e.g., data-settings-id)
			Object.entries(attributes).forEach(([key, value]) => {
				script.setAttribute(key, value);
			});

			setStatus('loading');

			// Script loading event
			script.onload = () => {
				setStatus('ready');
			};
			// Script error event
			script.onerror = () => {
				setStatus('error');
			};

			// Append the script to the document body
			document.body.appendChild(script);
		} else {
			// If script exists, set status to ready immediately
			setStatus('ready');
		}
	}, [url, attributes]); // The hook only updates when `url` or `attributes` change

	return status;
};

export default useScript;
